
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke-opacity":".88"}},[_c('g',{attrs:{"stroke":"#000","stroke-width":".81"}},[_c('g',[_c('g',[_c('path',{attrs:{"d":"M7.486 4.674L7.038 6.43c-.68 2.671-.68 5.47 0 8.142l.448 1.757c.367 1.435 1.461 2.572 2.882 2.993l1.622.48c.427.126.887.072 1.272-.151l.876-.508c.501-.29.728-.894.541-1.442l-.784-2.305c-.168-.492-.63-.824-1.15-.824h-1.029c-.52 0-.982-.33-1.15-.823l-.412-1.212c-.45-1.32-.45-2.752 0-4.072l.412-1.212c.168-.492.63-.823 1.15-.823h1.028c.52 0 .983-.332 1.15-.824l.785-2.305c.187-.548-.04-1.152-.54-1.443l-.876-.508c-.386-.223-.846-.278-1.273-.152l-1.622.481c-1.42.421-2.515 1.559-2.882 2.995z","transform":"translate(-35 -420) translate(15 399) translate(19 21) rotate(-45 10.5 10.5)"}})])])])])])
          )
        }
      }
    